<template>
  <div class="d-flex">
    <v-btn-toggle :model-value="value" @update:modelValue="onUpdate" :mandatory="mandatory" :disabled="disabled">
      <v-btn v-for="option in options" :key="option.value" :value="option.value">
        {{ option.label }}
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script setup>
const {
  value,
  options,
  mandatory,
  disabled
} = defineProps(
  {
    value: String,
    options: Array,
    mandatory: Boolean,
    disabled: Boolean
  })
const emit = defineEmits(['update:modelValue'])

const onUpdate = (newValue) => {
  emit('update:modelValue', newValue)
}
</script>

<style scoped>
:deep(.v-btn-group--density-default.v-btn-group.v-btn-toggle) {
  height: auto;

  .v-btn {
    padding: 1px 4px;
    background: #4f535909;
    border-top: 1px solid #bbbec4;
    border-bottom: 1px solid #bbbec4;
    box-shadow: 0 0 1px 0 #00000026;

    &:first-child {
      border-left: 1px solid #bbbec4;
      border-radius: 12px 0 0 12px !important;
    }

    &:last-child {
      border-radius: 0 12px 12px 0 !important;
      border-right: 1px solid #bbbec4;
    }

    &.v-btn--active {
      background: #4191f211;
      border: 1px solid #4191f2;

      .v-btn__overlay {
        opacity: 0;
      }

      .v-btn__content {
        color: #4191f2;
      }
    }

    &.v-btn--size-default {
      min-width: 40px;
    }

    .v-btn__content {
      color: #4f5359;
      font-size: 12px;
      line-height: 14px;
    }
  }
}
</style>
